export const KEY_SOURCE_PREFIX = "key:";

export const createKeySourceIdentifier = (keyId) => `${KEY_SOURCE_PREFIX}${keyId}`;

export const getKeyIdFromSourceIdentifier = (sourceIdentifier) => {
    if (typeof sourceIdentifier !== "string" || !sourceIdentifier.startsWith(KEY_SOURCE_PREFIX)) {
        return null;
    }

    return sourceIdentifier.substring(KEY_SOURCE_PREFIX.length);
};

export const isKeySourceIdentifier = (sourceIdentifier) => getKeyIdFromSourceIdentifier(sourceIdentifier) !== null;
